import { makeStyles, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import clsx from 'clsx';
import React from 'react';
import { TextLabel } from '../Inputs';

export const getValueFromOptions = (options, value) => {
  if (options && value !== null && value !== undefined && value !== '') {
    const returnValue = options.find((op) => op.id.toString().toLowerCase() === value.toString().toLowerCase());
    return returnValue || null;
  }
  return null;
};

export const removerAsterisk = (label, required, removerAsterisk) => {
  if (removerAsterisk) {
    return `${label}`;
  }
  return `${label}${required ? ' *' : ''}`;
};

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
    },
  },
});

function SelectInput({
  className,
  onChange,
  onBlur,
  id,
  error,
  touched,
  value,
  required,
  label,
  options,
  disabled,
  readOnly,
  fullWidth,
  openOnFocus,
  disableClearable = false,
  placeholder,
  removeAsterisk = false,
  noOptionsText = 'Nenhum registro encontrado',
  positionBottom = false,
}) {
  const classes = useStyles();

  if (readOnly) {
    return (
      <TextLabel
        disabled
        id={id}
        label={label}
        value={value && options && options.find((item) => item.id === value)?.title}
      />
    );
  }
  return (
    <Autocomplete
      className={className}
      id={id}
      name={id}
      options={options}
      noOptionsText={noOptionsText}
      getOptionLabel={(option) => option.title}
      fullWidth={fullWidth}
      onChange={(event, val) => {
        const valor = val ? val.id : val;
        onChange({ target: { id, value: valor } });
      }}
      value={getValueFromOptions(options, value)}
      disabled={disabled}
      openOnFocus={openOnFocus}
      disableClearable={disableClearable}
      disablePortal={positionBottom}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            className={clsx(params.className, classes.root)}
            label={removerAsterisk(label, required, removeAsterisk)}
            placeholder={placeholder}
            fullWidth
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onBlur={onBlur}
            error={required && error && touched}
            helperText={required && error && touched ? error : undefined}
          />
        );
      }}
    />
  );
}

export default SelectInput;
